"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import type { AIInsightsButtonProps } from "./types";

{
  /*
const SparkleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 2C12 2 13.2 7.5 19 8C13.2 8.5 12 14 12 14C12 14 10.8 8.5 5 8C10.8 7.5 12 2 12 2Z"
      fill="white"
    />
    <path
      d="M19.5 14.5C19.5 14.5 20 16.8 22 17C20 17.2 19.5 19.5 19.5 19.5C19.5 19.5 19 17.2 17 17C19 16.8 19.5 14.5 19.5 14.5Z"
      fill="white"
    />
    <path
      d="M5 17C5 17 5.4 18.6 7 19C5.4 19.4 5 21 5 21C5 21 4.6 19.4 3 19C4.6 18.6 5 17 5 17Z"
      fill="white"
    />
  </svg>
);
*/
}

const AIInsightsButton: React.FC<AIInsightsButtonProps> = ({
  onClick,
  onMouseEnter,
  position,
}) => {
  const isRight = position === "right";
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const check = () => {
      const w = window.innerWidth;
      if (w < 640) setScale(0.75);
      else if (w < 1024) setScale(0.8);
      else setScale(1);
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <motion.button
      className={`fixed z-50 flex items-center cursor-pointer
                  focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400
                  ${isRight ? "right-0 flex-row" : "left-3 flex-row-reverse"}`}
      style={{
        top: "calc(50% - 140px)",
        background: "linear-gradient(180deg, #B0D9F7 -19.78%, #0086E6 101.49%)",
        paddingTop: "12px",
        paddingBottom: "12px",
        paddingLeft: "12px",
        paddingRight: "12px",
        gap: "10px",
        transformOrigin: isRight ? "right top" : "left top",
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      aria-label="Open AI Insights"
      initial={{ x: isRight ? "130%" : "-130%", y: 0, opacity: 0, scale }}
      animate={{ x: 0, y: 0, opacity: 1, scale }}
      exit={{
        x: isRight ? "130%" : "-130%",
        y: 0,
        opacity: 0,
        transition: { duration: 0 },
      }}
      transition={{ type: "spring", stiffness: 280, damping: 22 }}
    >
      {/* Inward-pointing chevron */}
      <div aria-hidden="true">
        <Image
          src="/images/star02.svg"
          alt="Chevron Right"
          width={40}
          height={40}
        />
      </div>
      {/* AI icon circle with gradient background */}
      {/* <div
        className="w-[48px] h-[48px] rounded-full flex items-center justify-center flex-shrink-0"
        style={{ background: "#E6F3FD" }}
      >
        <Image src="/images/star.svg" alt="Star" width={29} height={25} />
      </div> */}
    </motion.button>
  );
};

export default AIInsightsButton;
